import {GiftCategory} from "@/store/gift/types";
import {Tr} from "@/i18n/i18n";
import {Keys} from "@/constants/key";
import {IntegrationUtils} from "@/utils/integration-utils";

export class TechUtils {

    public static isBigSpeed():boolean {
        if (IntegrationUtils.isExternalUser()){
            return false;
        }

        return window.location.href.indexOf("bigSpeed") != -1 &&
            (window.location.hostname.indexOf("lgtest.fun") != -1 ||  window.location.hostname.includes('localhost'));
    }
}
